import { render } from "./descriptionComponent.vue?vue&type=template&id=47ff7cd4"
import script from "./descriptionComponent.vue?vue&type=script&lang=js"
export * from "./descriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__